var _defs, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-square_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".logo-square_svg__cls-1{fill:#fff}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 9.69,
    ry: 9.69,
    fill: "#19ac4b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logo-square_svg__cls-1",
    d: "M19.75 42.52h6.13v11.1h-6.13zM42.75 13.97c-3.26-1.76-5.56-2.05-10.91-2.05H19.75v25.29h12.03c4.77 0 8.34-.29 11.49-2.39 3.43-2.27 5.22-6.05 5.22-10.45 0-4.71-2.2-8.51-5.75-10.42zm-9.56 17.95h-7.32V17.33l6.91-.04c6.29-.04 9.44 2.14 9.44 7.17 0 5.41-3.91 7.46-9.03 7.46z"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fS5jbHMtMntmaWxsOiMxOWFjNGI7fTwvc3R5bGU+PC9kZWZzPjxyZWN0IGNsYXNzPSJjbHMtMiIgeD0iMCIgeT0iMCIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiByeD0iOS42OSIgcnk9IjkuNjkiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjE5Ljc1IiB5PSI0Mi41MiIgd2lkdGg9IjYuMTMiIGhlaWdodD0iMTEuMSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0ibTQyLjc1LDEzLjk3Yy0zLjI2LTEuNzYtNS41Ni0yLjA1LTEwLjkxLTIuMDVoLTEyLjA5djI1LjI5aDEyLjAzYzQuNzcsMCw4LjM0LS4yOSwxMS40OS0yLjM5LDMuNDMtMi4yNyw1LjIyLTYuMDUsNS4yMi0xMC40NSwwLTQuNzEtMi4yLTguNTEtNS43NS0xMC40MmgwWm0tOS41NiwxNy45NWgtNy4zMnYtMTQuNTlsNi45MS0uMDRjNi4yOS0uMDQsOS40NCwyLjE0LDkuNDQsNy4xNywwLDUuNDEtMy45MSw3LjQ2LTkuMDMsNy40NloiLz48L3N2Zz4K";
export { SvgLogoSquare as ReactComponent };